"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.apiCallResult = apiCallResult;
exports.API_CALL_ERROR = exports.API_CALL_SUCCESS = exports.API_CALL_REQUESTED = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var API_CALL_REQUESTED = "@redux-api-client/API_CALL_REQUESTED";
exports.API_CALL_REQUESTED = API_CALL_REQUESTED;
var API_CALL_SUCCESS = "@redux-api-client/API_CALL_SUCCESS";
exports.API_CALL_SUCCESS = API_CALL_SUCCESS;
var API_CALL_ERROR = "@redux-api-client/API_CALL_ERROR";
exports.API_CALL_ERROR = API_CALL_ERROR;

function apiCallSuccess(options) {
  return _objectSpread({
    type: API_CALL_SUCCESS
  }, options);
}

function apiCallError(options) {
  return _objectSpread({
    type: API_CALL_ERROR
  }, options);
}

function apiCallResult(_ref) {
  var result = _ref.result,
      otherOptions = (0, _objectWithoutProperties2["default"])(_ref, ["result"]);
  var response = result.response,
      error = result.error;

  if (response) {
    return apiCallSuccess(_objectSpread({
      response: response
    }, otherOptions));
  }

  return apiCallError(_objectSpread({
    error: error
  }, otherOptions));
}